import { defineStore } from 'pinia'
import { ref, Ref, unref } from 'vue'

const TOKEN = 'new-dispatcher-sector'

import { DispatcherSector } from '@/new-services/types/dispatcher-sectors'

import { useLocalStorage } from 'vue-composable'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export const useNewDispatcherStore = defineStore('new-dispatcher-store', () => {
    const dispatcherSectorId = ref(null) as Ref<number | null>
    const isWithoutSectorId = ref(false)
    const dispatcherSector = ref(null) as Ref<DispatcherSector | null>
    const WITH_NULLABLE_ROUTES = [
        '/new-dispatcher/monitoring',
        '/new-dispatcher/deliveries',
        '/new-dispatcher/takes',
    ]
    const WITH_CUSTOM_ROUTES = ['/new-dispatcher/takes']
    const WITHOUT_SECTORS = ['/new-dispatcher/couriers']

    const validation$ = useVuelidate(
        {
            dispatcherSectorId: { required },
        },
        { dispatcherSectorId }
    )

    function initialize() {
        const { storage } = useLocalStorage(TOKEN)

        if (storage.value) {
            let storage_sector = undefined as DispatcherSector | undefined

            if (typeof storage.value === 'object') {
                storage_sector = storage.value
            }

            if (typeof storage.value === 'string' && storage.value !== 'undefined') {
                storage_sector = JSON.parse(storage.value)
            }

            if (storage_sector) {
                dispatcherSectorId.value = storage_sector.id
                dispatcherSector.value = { ...storage_sector }

                return
            }
        }
    }

    function syncWithLocalStorage() {
        const { storage } = useLocalStorage(TOKEN)

        if (dispatcherSector.value) {
            storage.value = JSON.stringify(unref(dispatcherSector.value))
        } else {
            storage.value = ''
        }
    }

    return {
        isWithoutSectorId,
        dispatcherSectorId,
        dispatcherSector,
        validation$,
        initialize,
        syncWithLocalStorage,
        WITH_NULLABLE_ROUTES,
        WITHOUT_SECTORS,
        WITH_CUSTOM_ROUTES,
    }
})
